import React from "react";
import { Avatar as MuiAvatar } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { avatarSizes } from "../constants/avatarConstants";

const useStyles = makeStyles(() => ({
    avatar: props => ({
        height: avatarSizes[props.size],
        width: avatarSizes[props.size]
    })
}));

const Avatar = ({ size, ...props }: { size?: any; [key: string]: any }) => {

    const classes = useStyles({ size });

    if (!avatarSizes[size])
        return <MuiAvatar { ...props } />    

    return <MuiAvatar className={classes.avatar} { ...props } />
};

export default Avatar;